import CommonTable from 'components/common/TableCommon';
import { ICluster } from 'interface/clusterInterface';
import { useEffect, useState } from 'react';
import { HeadCell } from 'components/common/TableCommon';
import { getTimeAgo } from 'utils/helper';
import { listClusters } from 'services/clusterService';
import { useAppSelector } from 'hooks/reduxHooks';
import { RootState } from 'redux-setup/store';
import { useNavigate } from 'react-router-dom';
import { Path } from 'router/constant';
import { toast } from 'react-toastify';
import { Loader } from 'components/common/loader';
import './styles.scss';

export const Clusters = () => {
  const navigate = useNavigate();
  const [clusters, setClusters] = useState<ICluster[]>([]);
  const [loading, setLoading] = useState(false);
  const limit = 25;

  const organizationID = useAppSelector(
    (state: RootState) => state.organization.id,
  );

  const handleListClusters = async () => {
    setLoading(true);
    const response = await listClusters({ OrganizationID: organizationID });
    const err = response.check();
    if (err) {
      toast.error('Error fetching clusters');
      return;
    }
    const clusters = response.unwrap();
    if (clusters.Result && clusters.Result.length > 0) {
      setClusters(clusters.Result);
      setLoading(false);
    } else {
      setClusters([]);
      setLoading(false);
    }
  };

  useEffect(() => {
    handleListClusters();
  }, []);

  const handleRowClick = (cluster: ICluster) => {
    navigate(`${Path.CLUSTERS}/${cluster.ID}`);
  };

  const headCellList: HeadCell<ICluster>[] = [
    { id: 'Name', label: 'Cluster Name' },
    { id: 'Server', label: 'Url' },
    { id: 'Version', label: 'Version' },
    {
      id: 'UpdatedAt',
      label: 'Last Updated',
      cellRender: (row: ICluster) => getTimeAgo(row.UpdatedAt),
    },
  ];

  if (loading) {
    return <Loader loading={loading} />;
  }

  return (
    <div className="clusters-container">
      <CommonTable<ICluster>
        headCellList={headCellList}
        data={clusters}
        isNextAPIDisabled={!clusters || clusters.length < limit}
        onRowClick={handleRowClick}
      />
    </div>
  );
};
